// Features que hoy tienen soporte operativo en el runtime del tenant.
// Platform no debería prometer activaciones de flags que todavía no están cableadas.
export const SUPPORTED_TENANT_FEATURE_KEYS = [
  'dashboard', 'payments', 'pricing', 'products', 'categories',
  'brands', 'collections', 'discounts', 'stock', 'purchases', 'suppliers',
  'clients', 'expenses', 'expense_categories', 'shifts', 'reports',
  'media', 'upload', 'web_analytics', 'product_history', 'imports', 'finance',
  'current_accounts', 'integrations_google_business',
  'settings_business', 'settings_web', 'payment_methods', 'staff', 'branches',
  'activity_logs', 'roles', 'projects',
  'calls', 'contact_forms', 'automations', 'message_templates', 'leads', 'estimates', 'invoices', 'points',
  'saas_management', 'multi_company',
] satisfies string[]

export const FEATURE_CATEGORIES: Record<string, { label: string; keys: string[] }> = {
  ventas: {
    label: 'Ventas',
    keys: ['payments', 'pricing', 'discounts'],
  },
  catalogo: {
    label: 'Catalogo',
    keys: ['products', 'categories', 'brands', 'collections'],
  },
  inventario: {
    label: 'Inventario',
    keys: ['stock', 'purchases', 'suppliers', 'product_history', 'imports'],
  },
  servicios: {
    label: 'Servicios',
    keys: ['projects', 'calls', 'agenda', 'appointments'],
  },
  crm: {
    label: 'CRM',
    keys: ['contact_forms', 'automations', 'message_templates', 'leads', 'estimates', 'invoices'],
  },
  finanzas: {
    label: 'Finanzas',
    keys: ['expenses', 'expense_categories', 'finance', 'current_accounts'],
  },
  equipo: {
    label: 'Equipo',
    keys: ['staff', 'roles', 'branches', 'shifts'],
  },
  plataforma: {
    label: 'Plataforma',
    keys: [
      'dashboard', 'clients', 'points', 'reports', 'media', 'upload', 'activity_logs',
      'settings_business', 'settings_web', 'payment_methods',
      'web_analytics', 'integrations_google_business',
      'saas_management',
      // No se puede desactivar si el tenant ya tiene empresas: lo rechaza platform-api.
      'multi_company',
    ],
  },
}
